var CSVParser = function() {
    var _self = this;
    _self.parseCSV = function(data) {
        return new Promise((resolve, reject) => {
            var csv = data;
            data = data.split("\n");
            var cache = [];
            var wells = [];
            
            // Quan. Raw Data
            for (let i = 0; i < data.length; i++) { if(data[i].trim() == "Quan. AmpData") var quanrawdataend = i; }
            for (let i = 0; i < quanrawdataend; i++) {
                let row = data[i].trim().split(",");
                if(row.length > 3 && row[3] !== "Target") {
                    let data = [];
                    for (let i = row.length-40; i < row.length; i++) {
                        data.push(parseFloat(row[i]));
                    }
                    if(!wells.includes(row[0])) {
                        wells.push(row[0]);
                    }
                    cache.push({
                        type: 'Quan. Raw Data',
                        well: row[0],
                        target: row[3],
                        data:data,
                    })
                }
            }
            
            // Quan. AmpData
            for (let i = 0; i < data.length; i++) { if(data[i].trim() == "Quan. Result") var quanampdataend = i; }
            for (let i = quanrawdataend; i < quanampdataend; i++) {
                let row = data[i].trim().split(",");
                if(row.length > 10 && row[3] !== "Target") {
                    let data = [];
                    for (let i = row.length-40; i < row.length; i++) {
                        data.push( { cycle: i-4, value: parseFloat(row[i].substring(0,9)), target: row[3] });
                    }
                    cache.push({
                        type: 'Quan. AmpData',
                        well: row[0],
                        target: row[3],
                        data:data,
                    })
                }
            }
            
            // Quan. Result
            for (let i = quanampdataend; i < data.length; i++) {
                let row = data[i].trim().split(",");
                if(row.length > 10 && row[3] !== "Target") {
                    let data = [];
                    cache.push({
                        type: 'Quan. Result',
                        well: row[0],
                        target: row[3],
                        sample: row[1],
                        ct: parseFloat(row[5]),
                        ctmean: parseFloat(row[6]),
                        id: i,
                    })
                }
            }
            resolve({
                wells: wells,
                cache: cache,
                raw: csv,
            });
        })
    }
}

export default CSVParser;